import type { FC } from 'react';
import {
  Box,
  Button,
  Link,
  styled,
  Stack,
  alpha} from '@mui/material';
import Logo from '~/components/Logo'
import { Link as RouteLink } from 'react-router-dom'
import { THEMES } from '~/constants';
import useSettings from '~/hooks/useSettings';
import { useAuthState } from 'ra-core';


const SignInOutlined = styled(Button)(({theme}) => {
  const baseColor = '#ffffff' //theme.palette.background.paper

  return {
    '&:hover': {
      border: `1px solid ${baseColor}`,
      backgroundColor: alpha(
        baseColor,
        theme.palette.action.hoverOpacity,
      ),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },

    padding: '5px 15px',
    color: baseColor,
    border: `1px solid ${alpha(baseColor, 0.5)}`,
  }
})


const SignUpDark = styled(Button)(({theme}) => ({
  color: theme.palette.getContrastText('#01139B'),
  backgroundColor: '#01139B',
  '&:hover': {
    backgroundColor: '#543ecd',
  },
}))


const AuthBanner: FC<{ withSiginIn?:boolean }> = ({
  withSiginIn,
}) => {
  const { settings } = useSettings()
  const { loading, authenticated } = useAuthState()

  return (
    <Box
      sx={{
        backgroundColor: 'primary.main',
        borderBottom: 1,
        borderColor: 'divider',
        py: 1,
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <Box sx={{mr: 'auto', ml: 4}} >
          <Link
            underline="hover"
            component={RouteLink}
            to="/login"
          >
            <Logo />
          </Link>
        </Box>
        {withSiginIn && (loading || !authenticated) &&
          <Stack direction="row" spacing={2} sx={{ mr: 2 }}>
            <SignInOutlined
              variant="outlined"
              href="/login"
            >
              Sign In
            </SignInOutlined>
            {settings.theme === THEMES.LIGHT ?
              <Button
                color={"info" as any}
                variant="contained"
                href="/register"
                >
                Sign Up
              </Button> :
              <SignUpDark
                variant="outlined"
                href="/register"
              >
                Sign Up
              </SignUpDark>
            }
          </Stack>
        }
      </Box>
    </Box>
  )
};

export default AuthBanner;
